var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlogViewsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.76833C11.2044 9.76833 10.4413 10.0841 9.87868 10.6461C9.31607 11.2082 9 11.9705 9 12.7653C9 13.5601 9.31607 14.3224 9.87868 14.8845C10.4413 15.4465 11.2044 15.7623 12 15.7623C12.7956 15.7623 13.5587 15.4465 14.1213 14.8845C14.6839 14.3224 15 13.5601 15 12.7653C15 11.9705 14.6839 11.2082 14.1213 10.6461C13.5587 10.0841 12.7956 9.76833 12 9.76833ZM12 17.7602C10.6739 17.7602 9.40215 17.234 8.46447 16.2973C7.52678 15.3605 7 14.09 7 12.7653C7 11.4406 7.52678 10.1701 8.46447 9.23334C9.40215 8.29661 10.6739 7.77036 12 7.77036C13.3261 7.77036 14.5979 8.29661 15.5355 9.23334C16.4732 10.1701 17 11.4406 17 12.7653C17 14.09 16.4732 15.3605 15.5355 16.2973C14.5979 17.234 13.3261 17.7602 12 17.7602ZM12 5.27289C7 5.27289 2.73 8.37974 1 12.7653C2.73 17.1509 7 20.2577 12 20.2577C17 20.2577 21.27 17.1509 23 12.7653C21.27 8.37974 17 5.27289 12 5.27289Z",
    className: "fill",
    fill: "#3E6E9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogViewsIcon);
export default __webpack_public_path__ + "static/media/blog-views-icon.2d42e0add25dc8b5f2a5b9f11b23d344.svg";
export { ForwardRef as ReactComponent };